export const RECURRING_TYPES = [
  'every_week',
  'every_month',
  'twice_monthly',
  'when_funds_drop_below',
];
